import React from 'react';
import './infographics.scss';
import { lang } from '../lang';

function InfographicHead({ index }) {
  const { head, copy, color } = lang.infographic[index];
  return (
    <div className={`infographics__head infographics__head-${index}`}>
      <h3 className={`${color}gradient infographics__head__header-${index}`}>{head}</h3>
      <p>{copy}</p>
    </div>
  );
}

export default InfographicHead;
